document.addEventListener('DOMContentLoaded', () => {
  /**
   * Main function to initialize all header logic.
   */
  const initHeader = () => {
    const navBar = document.querySelector('.nav-bar__container');
    const announcementBar = document.querySelector('#qab_background, .announcement-bar-section');
    if (!navBar) return;

    // --- Other Header Elements & Logic (like mobile drawer) ---
    const navOpenBtn = document.querySelector('.nav-drawer__open-btn');
    const navCloseBtn = document.querySelector('.nav-drawer__close-btn');
    const navDrawer = document.querySelector('.nav-bar__menu');

    if (navOpenBtn && navCloseBtn && navDrawer) {
      navOpenBtn.addEventListener('click', () => navDrawer.classList.add('open'));
      navCloseBtn.addEventListener('click', () => navDrawer.classList.remove('open'));
    }

    // --- Sticky Header Logic ---
    let lastScrollTop = 0;
    const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;

    // ✅ NEW: Detect if the announcement bar is sticky
    let isAnnounceBarSticky = false;
    if (announcementBar) {
      const barStyle = window.getComputedStyle(announcementBar);
      isAnnounceBarSticky = barStyle.position === 'sticky' || barStyle.position === 'fixed';
    }

    navBar.style.top = `${announcementBarHeight}px`;
    document.body.classList.add('header-is-ready');

    window.addEventListener('scroll', () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // Logic for adding a shadow when sticky
      if (scrollTop > announcementBarHeight) {
        navBar.classList.add('is-sticky');
      } else {
        navBar.classList.remove('is-sticky');
      }

      // ✅ NEW: Apply different logic based on whether the announcement bar is sticky
      if (isAnnounceBarSticky) {
        // --- SCENARIO 1: The Announcement Bar is STICKY ---
        if (navBar.classList.contains('always')) {
          // Header's position is fixed below the announcement bar and never changes.
          navBar.style.top = `${announcementBarHeight}px`;
        } else if (navBar.classList.contains('scroll_up')) {
          // Check scroll direction, but only after passing the header's initial height
          if (scrollTop > lastScrollTop && scrollTop > announcementBarHeight) { // Scrolling Down
            navBar.style.top = `-${navBar.offsetHeight}px`; // Hide header
          } else { // Scrolling Up or at the top
            navBar.style.top = `${announcementBarHeight}px`; // Show header below the sticky bar
          }
        }
      } else {
        // --- SCENARIO 2: The Announcement Bar is NOT STICKY (it scrolls away) ---
        // This is our previous "hugging" logic, which is correct for this case.
        if (navBar.classList.contains('always')) {
          const newTop = Math.max(0, announcementBarHeight - scrollTop);
          navBar.style.top = `${newTop}px`;
        } else if (navBar.classList.contains('scroll_up')) {
          if (scrollTop <= announcementBarHeight) {
            const newTop = Math.max(0, announcementBarHeight - scrollTop);
            navBar.style.top = `${newTop}px`;
          } else {
            if (scrollTop > lastScrollTop) {
              navBar.style.top = `-${navBar.offsetHeight}px`;
            } else {
              navBar.style.top = '0';
            }
          }
        }
      }
      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    });
  };

  /**
   * This is the "poller" that waits for an announcement bar.
   * It includes a timeout to handle the "no bar" scenario.
   */
  let attempts = 0;
  const maxAttempts = 20; // Try 20 times over 2 seconds (20 * 100ms)

  const waitForBar = setInterval(() => {
    attempts++;
    const barElement = document.querySelector('#qab_background, .announcement-bar-section');

    // SUCCESS condition: A bar is found and it has a real height.
    if (barElement && barElement.offsetHeight > 0) {
      clearInterval(waitForBar);
      initHeader();
      return;
    }

    // TIMEOUT condition: We've waited long enough and found no bar.
    if (attempts >= maxAttempts) {
      clearInterval(waitForBar);
      initHeader(); // Initialize the header without an announcement bar.
    }
  }, 100);
});